import { v4 as uuid4 } from 'uuid';
import { type Feature, FeatureType } from '../api';

/**
 * Create a `Feature` object from a WKT geometry string.
 *
 * @param wkt - Well-known text representation of the geometry (e.g. "POLYGON((...))").
 * @param layerId - Identifier of the layer the feature will belong to.
 * @param featureType - Optional feature geometry type. Defaults to `FeatureType.Polygon`.
 * 
 * @returns A new `Feature` with a generated `id`, the provided `layer`, `geometry`, and `type`.
 *
 */
export const createFeatureFromWKT = (
  wkt: string,
  layerId: string,
  featureType = FeatureType.Polygon,
): Feature => ({
  id: uuid4(),
  layer: layerId,
  geometry: wkt,
  type: featureType,
});
